import Vue from "vue";
import store from "../store";
import VueRouter from "vue-router";
import routes from "./routes";
import { displayNotification } from "@/common/notification";
import {
  CHECK_AUTH
} from "../store/actions.type";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: "active"
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)

  if (requiresAuth) {
    await store.dispatch(CHECK_AUTH)
  }

  const currentUser = store.getters.currentUser
  const isAuthenticated = store.getters.isAuthenticated

  if (requiresAuth && !isAuthenticated) {
    return next('/login')
  }

  const requiresAccess = to.matched.some(x => x.meta.requiresAccess)
  const paths = to.fullPath.split('/')

  let canUserAccessRoute = true

  if (requiresAccess) {
    const userAccess = Array.isArray(currentUser.access) ? currentUser.access : []
    canUserAccessRoute = userAccess.indexOf(paths[1]) !== -1

    // check if user is trying to update self
    // users/update/<user_id>
    if (paths[3] === currentUser.id) {
      canUserAccessRoute = true
    }
  } 

  if (requiresAuth && canUserAccessRoute) {
    next()
  } else if (requiresAuth && !canUserAccessRoute) {
    displayNotification('You don\'t have access to this page', 'warning')
    next('/dashboard')
  } else {
    next()
  }
})

export default router;
